export default {
	meta: {
		title: 'Convention',
		description: 'Convention'
	}
};
